import MainRoutes from "./routes/MainRoutes";

function App() {
  return (
    <div>
      <MainRoutes/>
    </div>
  );
}

export default App;
